import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const serviceLinks = [
    { name: 'Office Cleaning', path: '/services/office-cleaning' },
    { name: 'Retail Cleaning', path: '/services/retail-cleaning' },
    { name: 'Medical Facility', path: '/services/medical-facility-cleaning' },
    { name: 'Industrial Cleaning', path: '/services/industrial-cleaning' },
    { name: 'Window Cleaning', path: '/services/window-cleaning' },
  ];

  return (
    <footer className="bg-teal-500 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-12 mb-12">
          {/* Left: Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-white rounded-lg">
                <i className="ri-sparkling-2-fill text-teal-500 text-xl"></i>
              </div>
              <span className="text-2xl font-bold font-['Poppins']">First Insight Cleaning</span>
            </div>

            <p className="text-white/80 mb-8 leading-relaxed">
              Professional cleaning services you can trust. Serving businesses with excellence for over 15 years.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-3">
              {serviceLinks.map((service, index) => (
                <li key={index}>
                  <a
                    href={service.path}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(service.path);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    className="text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('service-tiers')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Service Tiers
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+15028308648" className="text-white/80 hover:text-white transition-colors">
                  (502) 830-8648
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:Sales@firstinsightcleaning.com" className="text-white/80 hover:text-white transition-colors">
                  Sales@firstinsightcleaning.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span className="text-white/80">
                  4916 Cawood Dr<br />
                  Louisville, KY 40218
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} First Insight Cleaning. All rights reserved.
          </p>
          
          {/* Minimized Readdy Link */}
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-slate-600 hover:text-slate-500 text-xs transition-colors opacity-40 hover:opacity-60"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
